export enum Bonus
{
	None = "None",
	FreeGameBonus = "FreeGameBonus",
	PickBonus = "PickBonus",
	SpinAndHold = "SpinAndHold",
	BigSymbolFreegames = "BigSymbolFreegames",
	BigSymbolSpinAndHold = "BigSymbolSpinAndHold",
	ExtendedSpinAndHold = "ExtendedSpinAndHold",
	MultiBonus = "MultiBonus",
}